import { useTranslation } from "react-i18next";

import { FilterOutlined } from "@ant-design/icons";
import { Row, Select, Space } from "antd";
import { Button, CardContainer } from "components/elements";

function EmployeePerformanceLearning({
  selectedYear = null,
  onFilter = () => {},
  onYearChange = () => {},
}) {
  const { t } = useTranslation();

  return (
    <Space style={{ width: "100%" }} size={24} direction="vertical">
      <Row justify="space-between">
        <Select
          value={selectedYear}
          defaultValue={selectedYear}
          onChange={onYearChange}
          style={{ width: 120 }}
          options={[]}
        />
        <Button type="default" onClick={onFilter}>
          {t("common.filter")} <FilterOutlined />
        </Button>
      </Row>
      <CardContainer>
        <div style={{ height: 200, padding: "1rem" }}>LEARNING</div>
      </CardContainer>
    </Space>
  );
}

export default EmployeePerformanceLearning;
